/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { defaults } from 'underscore';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UILink from 'UIComponents/link/UILink';
import UIIcon from 'UIComponents/icon/UIIcon';
import EditFormBreadcrumbs from 'ContentComponents/components/cmv2/EditFormBreadcrumbs';
import { CALYPSO } from 'HubStyleTokens/colors';
import { getDisplayName, getHasUndoRedoAccess } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { getSelectedModuleName, getSelectedItemInTree, getSelectedItemId, getSelectedModuleSchema, getSelectedModuleBodyAsJSObject } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import BaymaxSidebarHeaderContainer from 'ContentEditorUI/containers/BaymaxSidebarHeaderContainer';
import { SIDEBAR_PANELS } from 'ContentEditorUI/lib/sidebar/constants';
import { getActiveSidebarPanel, getPreviousSidebarPanel, getSelectedField, getIsPatagoniaSidebarCollapsed } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { setDirtyFlag, setIframeLoading } from 'ContentEditorUI/redux/actions/appActions';
import { clearSelectedItem } from 'ContentEditorUI/redux/actions/selectionActions';
import { updateSelectedField } from 'ContentEditorUI/redux/actions/editSidebarActions';
import withEditorActionsAndEvents from 'ContentEditorUI/components/hoc/withEditorActionsAndEvents';
import { fetchPageCssAssets } from 'ContentEditorUI/redux/actions/contentAssetsActions';
import { getPreviewIframeNeedsRefresh } from 'ContentEditorUI/redux/selectors/inpageSelectors';
import { openPreviousPanel, closePatagoniaSidebar, setActivePatagoniaPanel } from 'ContentEditorUI/redux/actions/panelActions';
import { getNodeType } from 'ContentEditorUI/utils/layoutSectionTreeUtils';
import { getIsUngatedForPatagonia } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getIsDataAuthoringModeActive } from 'ContentEditorUI/redux/selectors/instanceEditingSelectors';
import { selectInstanceValues, selectTableAsModuleSchema } from 'structured-content-lib/redux/selectors/instanceEditSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapStateToProps = state => {
  const selectedModuleName = getSelectedModuleName(state);
  return {
    displayName: getDisplayName(state, selectedModuleName),
    activePanel: getActiveSidebarPanel(state),
    hasUndoRedoAccess: getHasUndoRedoAccess(state),
    iframeNeedsRefresh: getPreviewIframeNeedsRefresh(state),
    selectedModuleName,
    node: getSelectedItemInTree(state),
    selectedItemId: getSelectedItemId(state),
    previousPanel: getPreviousSidebarPanel(state),
    selectedField: getSelectedField(state),
    selectedModuleSchema: getSelectedModuleSchema(state),
    selectedModuleBodyAsJSObject: getSelectedModuleBodyAsJSObject(state),
    isUngatedForPatagonia: getIsUngatedForPatagonia(state),
    isPatagoniaSidebarCollapsed: getIsPatagoniaSidebarCollapsed(state),
    isDataAuthoringModeActive: getIsDataAuthoringModeActive(state),
    instanceValues: selectInstanceValues(state),
    tableAsModuleSchema: selectTableAsModuleSchema(state)
  };
};
const mapDispatchToProps = {
  setDirtyFlag,
  clearSelectedItem,
  setIframeLoading,
  fetchPageCssAssets,
  openPreviousPanel,
  updateSelectedField,
  closePatagoniaSidebar,
  setActivePanel: setActivePatagoniaPanel
};
class SidebarHeader extends Component {
  constructor(props) {
    super(props);
    this.refreshPreview = this.refreshPreview.bind(this);
    this.onModuleSubmit = this.onModuleSubmit.bind(this);
    this.endEditView = this.endEditView.bind(this);
    this.saveModuleCallback = this.saveModuleCallback.bind(this);
    this.clearSelectedField = this.clearSelectedField.bind(this);
  }
  endEditView(moduleToHighlight) {
    this.props.clearSelectedItem();
    if (moduleToHighlight) {
      this.props.openPreviousPanel();
    }
  }
  onModuleSubmit(opts) {
    const options = defaults(opts, {
      shouldRefreshPreview: true,
      shouldReturnToList: true,
      moduleToHighlight: '',
      shouldResetFocusedWidget: true
    });
    const {
      shouldRefreshPreview,
      moduleToHighlight,
      shouldReturnToList,
      shouldResetFocusedWidget
    } = options;
    this.props.setDirtyFlag(true);
    if (shouldResetFocusedWidget) {
      this.props.clearSelectedItem();
      if (shouldRefreshPreview) {
        return;
      }
    }
    if (shouldRefreshPreview) {
      this.refreshPreview(!shouldResetFocusedWidget && !shouldReturnToList);
    }
    if (shouldReturnToList) {
      this.endEditView(moduleToHighlight);
    }
  }
  saveModuleCallback() {
    const {
      iframeNeedsRefresh,
      selectedItemId,
      isUngatedForPatagonia,
      isPatagoniaSidebarCollapsed
    } = this.props;
    this.onModuleSubmit({
      moduleToHighlight: selectedItemId,
      shouldRefreshPreview: iframeNeedsRefresh
    });
    if (isUngatedForPatagonia && !isPatagoniaSidebarCollapsed) {
      this.props.closePatagoniaSidebar();
    }
  }
  refreshPreview() {
    const {
      bus,
      saveActions
    } = this.props;
    this.props.setIframeLoading();
    saveActions.autoSave().then(() => {
      this.props.fetchPageCssAssets();
      bus.trigger('preview:refresh');
    });
  }
  clearSelectedField() {
    this.props.updateSelectedField(null);
  }
  renderSidebarHeaderLabel() {
    const {
      displayName,
      activePanel,
      node
    } = this.props;
    const displayNameToUse = displayName || I18n.text('editOverlay.pageStyles');
    if (activePanel === SIDEBAR_PANELS.edit) {
      if (displayName) {
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "editOverlay.header",
          options: {
            displayName: displayNameToUse
          }
        });
      } else {
        const layoutItemType = node && getNodeType(node);
        if (layoutItemType) {
          return /*#__PURE__*/_jsx(FormattedMessage, {
            message: `app.layoutStyles.editStyles-cleanLines-${layoutItemType}`
          });
        }
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "editOverlay.header",
          options: {
            displayName: I18n.text('editOverlay.pageStyles')
          }
        });
      }
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "editSidebarHeader"
    });
  }
  renderBaymaxBreadcrumbs() {
    const {
      activePanel,
      previousPanel,
      selectedField,
      selectedModuleSchema,
      selectedModuleBodyAsJSObject
    } = this.props;
    let breadcrumbMessage = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "editOverlay.sidebarHomeLink"
    });
    if (activePanel === SIDEBAR_PANELS.edit && previousPanel === SIDEBAR_PANELS.optimizer) {
      breadcrumbMessage = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "sidebar.optimizer"
      });
    }
    const showHomeIcon = activePanel !== SIDEBAR_PANELS.edit || previousPanel !== SIDEBAR_PANELS.optimizer;
    return /*#__PURE__*/_jsx(EditFormBreadcrumbs, {
      fieldKey: selectedField,
      fields: selectedModuleSchema ? selectedModuleSchema.fields : null,
      module: selectedModuleBodyAsJSObject,
      onKeyChange: this.props.updateSelectedField,
      className: "breadcrumbs",
      hideBottomBorder: true,
      rootBreadcrumbs: [/*#__PURE__*/_jsxs(UILink, {
        onClick: this.saveModuleCallback,
        className: "breadcrumb-label",
        "data-selenium": "save-and-go-to-module-list",
        children: [showHomeIcon && /*#__PURE__*/_jsx(UIIcon, {
          name: "home",
          color: CALYPSO
        }), breadcrumbMessage]
      }, "home-breadcrumb"), activePanel === SIDEBAR_PANELS.edit ? /*#__PURE__*/_jsx(UILink, {
        onClick: this.clearSelectedField,
        disabled: !selectedField,
        children: this.renderSidebarHeaderLabel()
      }, "selected-item-name-breadcrumb") : null]
    });
  }
  returnToRootPatagoniaPanel(panelType) {
    this.props.clearSelectedItem({
      returnToPreviousPanel: true
    });
    this.props.setActivePanel(panelType);
  }
  renderPatagoniaBreadcrumbs() {
    const {
      activePanel,
      previousPanel,
      selectedField,
      selectedModuleSchema,
      selectedModuleBodyAsJSObject,
      isDataAuthoringModeActive
    } = this.props;
    const currentBreadCrumb = activePanel === SIDEBAR_PANELS.edit ? /*#__PURE__*/_jsx(UILink, {
      onClick: this.clearSelectedField,
      disabled: !selectedField,
      children: this.renderSidebarHeaderLabel()
    }, "selected-item-name-breadcrumb") : null;
    const homePanel = previousPanel === SIDEBAR_PANELS.optimizer ? SIDEBAR_PANELS.optimizer : SIDEBAR_PANELS.pageContents;
    const homeBreadcrumb = /*#__PURE__*/_jsx(UILink, {
      onClick: () => this.returnToRootPatagoniaPanel(homePanel),
      className: "breadcrumb-label",
      "data-selenium": "save-and-go-to-module-list",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `patagonia.sidebar.tooltipLabel.${homePanel}`
      })
    }, "home-breadcrumb");
    const rootBreadcrumbs = [homeBreadcrumb, currentBreadCrumb];
    if (isDataAuthoringModeActive) {
      return /*#__PURE__*/_jsx(EditFormBreadcrumbs, {
        fieldKey: selectedField,
        fields: this.props.tableAsModuleSchema.fields,
        module: this.props.instanceValues,
        onKeyChange: this.props.updateSelectedField,
        className: "breadcrumbs patagonia",
        hideBottomBorder: true,
        rootBreadcrumbs: rootBreadcrumbs
      });
    }
    return /*#__PURE__*/_jsx(EditFormBreadcrumbs, {
      fieldKey: selectedField,
      fields: selectedModuleSchema ? selectedModuleSchema.fields : null,
      module: selectedModuleBodyAsJSObject,
      onKeyChange: this.props.updateSelectedField,
      className: "breadcrumbs patagonia",
      hideBottomBorder: true,
      rootBreadcrumbs: rootBreadcrumbs
    });
  }
  renderBreadcrumbs() {
    const {
      isUngatedForPatagonia
    } = this.props;
    if (isUngatedForPatagonia) {
      return this.renderPatagoniaBreadcrumbs();
    }
    return this.renderBaymaxBreadcrumbs();
  }
  render() {
    const {
      hasUndoRedoAccess,
      showDeviceToggle,
      isUngatedForPatagonia
    } = this.props;
    return /*#__PURE__*/_jsx(BaymaxSidebarHeaderContainer, {
      breadcrumbs: this.renderBreadcrumbs(),
      headerLabel: this.renderSidebarHeaderLabel(),
      showUndoRedoButtons: hasUndoRedoAccess && !isUngatedForPatagonia,
      showDeviceToggle: showDeviceToggle && !isUngatedForPatagonia,
      closePatagoniaSidebarCallback: this.saveModuleCallback
    });
  }
}
SidebarHeader.propTypes = {
  displayName: PropTypes.string,
  activePanel: PropTypes.string.isRequired,
  hasUndoRedoAccess: PropTypes.bool.isRequired,
  showDeviceToggle: PropTypes.bool.isRequired,
  setDirtyFlag: PropTypes.func.isRequired,
  setIframeLoading: PropTypes.func.isRequired,
  fetchPageCssAssets: PropTypes.func.isRequired,
  iframeNeedsRefresh: PropTypes.bool.isRequired,
  openPreviousPanel: PropTypes.func.isRequired,
  node: PropTypes.object,
  selectedItemId: PropTypes.string,
  clearSelectedItem: PropTypes.func,
  previousPanel: PropTypes.string.isRequired,
  selectedField: PropTypes.object,
  selectedModuleSchema: PropTypes.object,
  updateSelectedField: PropTypes.func.isRequired,
  selectedModuleBodyAsJSObject: PropTypes.object,
  saveActions: PropTypes.object.isRequired,
  bus: PropTypes.object.isRequired,
  isUngatedForPatagonia: PropTypes.bool,
  isPatagoniaSidebarCollapsed: PropTypes.bool,
  isDataAuthoringModeActive: PropTypes.bool,
  instanceValues: PropTypes.object,
  tableAsModuleSchema: PropTypes.object,
  closePatagoniaSidebar: PropTypes.func,
  setActivePanel: PropTypes.func
};
export default connect(mapStateToProps, mapDispatchToProps)(withEditorActionsAndEvents(SidebarHeader));